var exports = {
  "Pc": "StickerFormFields.module__tagsContainer___ZHhrZH",
  "Pr": "StickerFormFields.module__tagsHeader___ZHhrZH",
  "cm": "StickerFormFields.module__tagsLabel___ZHhrZH",
  "jw": "StickerFormFields.module__tagInputRow___ZHhrZH",
  "Cs": "StickerFormFields.module__tagsList___ZHhrZH",
  "Tc": "StickerFormFields.module__tag___ZHhrZH",
  "xH": "StickerFormFields.module__tagRemoveButton___ZHhrZH",
};

module.exports = exports;
